module.exports = __webpack_public_path__ + "static/media/building6.fc40f7fc.svg";